import { BaseService } from './base.service';
import { CustomTrainingForm, CreateFormRequest, UpdateFormRequest } from '../models/training.models';

export default class CustomTrainingFormsService extends BaseService {
  public async listForms(teamId: string) {
    return this.axios.get<{ status: number; message: string; data: CustomTrainingForm[] }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-forms`
    );
  }

  public async getForm(teamId: string, formId: number) {
    return this.axios.get<{ status: number; message: string; data: CustomTrainingForm }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-forms/${formId}`
    );
  }

  public async createForm(teamId: string, data: CreateFormRequest) {
    return this.axios.post<{ status: number; message: string; data: CustomTrainingForm }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-forms`,
      data
    );
  }

  public async updateForm(teamId: string, formId: number, data: UpdateFormRequest) {
    return this.axios.patch<{ status: number; message: string; data: CustomTrainingForm }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-forms/${formId}`,
      data
    );
  }

  public async deleteForm(teamId: string, formId: number) {
    return this.axios.delete<{ status: number; message: string; data: CustomTrainingForm }>(
      `${this.backendUrl}/teams/${teamId}/custom-training-forms/${formId}`
    );
  }
}
